import { createAction, props } from '@ngrx/store';
import { Wallet, Facturation } from '@core/models/wallet.model';
import { CurrencyIso } from '@core/utils/currency.utils';

// Load wallets
export const loadWallets = createAction('[Wallet] Load Wallets', props<{ clientIds: string[]; grandCompteId: number; currency: CurrencyIso }>());

export const loadWalletsSuccess = createAction(
    '[Wallet API] Load Wallets Success',
    props<{
        wallets: {
            clientId: string;
            advertiserName: string;
            grandCompteId: number;
            wallet: Wallet | null;
        }[];
    }>(),
);

export const loadWalletsFailure = createAction('[Wallet API] Load Wallets Failure', props<{ error: string }>());

// Load single wallet balance
export const loadWalletBalance = createAction('[Wallet] Load Wallet Balance', props<{ clientId: string; walletId: string; currency: CurrencyIso }>());

export const loadWalletBalanceSuccess = createAction('[Wallet API] Load Wallet Balance Success', props<{ walletId: string; balance: number }>());

export const loadWalletBalanceFailure = createAction('[Wallet API] Load Wallet Balance Failure', props<{ error: string }>());

// Load facturations
export const loadFacturations = createAction('[Facturation] Load Facturations', props<{ clientIds: string[]; grandCompteId: number }>());

export const loadFacturationsSuccess = createAction(
    '[Facturation API] Load Facturations Success',
    props<{
        facturations: {
            clientId: string;
            advertiserName: string;
            grandCompteId: number;
            facturation: Facturation | null;
        }[];
    }>(),
);

export const loadFacturationsFailure = createAction('[Facturation API] Load Facturations Failure', props<{ error: string }>());

// Update facturation
export const updateFacturation = createAction('[Facturation] Update Facturation', props<{ clientId: string; facturation: Facturation }>());

export const updateFacturationSuccess = createAction(
    '[Facturation API] Update Facturation Success',
    props<{ clientId: string; facturation: Facturation }>(),
);

export const updateFacturationFailure = createAction('[Facturation API] Update Facturation Failure', props<{ error: string }>());

// Set current selections
export const setCurrentWallet = createAction('[Wallet] Set Current Wallet', props<{ clientId: string; grandCompteId: number }>());

export const setCurrentFacturation = createAction('[Facturation] Set Current Facturation', props<{ clientId: string; grandCompteId: number }>());

// Clear data
export const clearWalletsAndFacturations = createAction('[Wallet/Facturation] Clear All Data');

// Update wallets for currency conversion
